import { useQuery } from "@tanstack/react-query";
import React from "react";
import { getFarmersFields } from "../../../services/api";

function StationServiceChecker({ data }) {
  const farmersFieldsQuery = useQuery(["farmersFields"], getFarmersFields);

  const cliamatichHistoryId =
    farmersFieldsQuery?.data?.farmersFields?.WEATHER_STATION_SERVICE
      ?.CLIMATE_INFORMATION;
  const weatherWarningId =
    farmersFieldsQuery?.data?.farmersFields?.WEATHER_STATION_SERVICE
      ?.WEATHER_WARNINGS;
  const dailyWeatherForcastId =
    farmersFieldsQuery?.data?.farmersFields?.WEATHER_STATION_SERVICE
      ?.DAILY_WEATHER_FORECAST;
  return (
    <div className="flex flex-row gap-5">
      <section>
        {data.servicesIds.find(
          (item) => item === dailyWeatherForcastId || item === weatherWarningId
        ) ? (
          <div className="button-neo justify-between items-center !w-[130px] flex flex-row p-1 gap-1">
            <div className="!w-[1rem] !h-[1rem] animate-pulse blur-[1px] rounded-full bg-green-600"/>
            <p>ربات پیش آگاهی  </p>
          </div>
        ) : (
            <div className="button-neo justify-between items-center !w-[130px] flex flex-row p-1 gap-1">
            <div className="!w-[1rem] !h-[1rem] animate-pulse blur-[1px] rounded-full bg-red-600"/>
            <p>ربات پیش آگاهی  </p>
          </div>
        )}
      </section>
      <section>
        {" "}
        {data.servicesIds.find(
          (item) => item === cliamatichHistoryId
        ) ? (
            <div className="button-neo justify-between items-center !w-[130px] flex flex-row p-1 gap-1">
            <div className="!w-[1rem] !h-[1rem] animate-pulse blur-[1px] rounded-full bg-green-600"/>
            <p className="mx-auto">اطلاعات اقلیمی</p>
          </div>
        ) : (
            <div className="button-neo justify-between items-center !w-[130px] flex flex-row p-1 gap-1">
            <div className="!w-[1rem] !h-[1rem] animate-pulse blur-[1px] rounded-full bg-red-600"/>
            <p className="mx-auto">اطلاعات اقلیمی</p>
          </div>
        )}
      </section>
    </div>
  );
}

export default StationServiceChecker;
